// extracted by mini-css-extract-plugin
export default {"document":"wsKEm","image":"H4EBl","title":"bsbq9"};